// Handgetekende accenten (SVG, currentColor). Decoratief: aria-hidden.
const base = { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": true };

export const HandUnderline = ({ className = "" }) => (
  <svg viewBox="0 0 200 14" preserveAspectRatio="none" className={`draw-line ${className}`} {...base} strokeWidth="3">
    <path d="M3 9 C 40 3, 90 3, 120 7 S 180 11, 197 4" />
  </svg>
);

export const Burst = ({ className = "" }) => (
  <svg viewBox="0 0 40 40" className={className} {...base} strokeWidth="3">
    <path d="M8 30 L15 23" /><path d="M14 10 L18 19" /><path d="M30 8 L25 18" />
  </svg>
);

export const Swoosh = ({ className = "" }) => (
  <svg viewBox="0 0 80 30" className={className} {...base} strokeWidth="4">
    <path d="M4 22 C 25 10, 50 8, 76 6" /><path d="M14 27 C 32 20, 50 18, 66 16" opacity=".6" />
  </svg>
);

export const Leaf = ({ className = "" }) => (
  <svg viewBox="0 0 100 100" className={`leaf-sway ${className}`} {...base} strokeWidth="2.5">
    <path d="M20 90 C 40 70, 55 50, 80 12" />
    <path d="M38 68 C 22 62, 16 50, 18 40 C 30 44, 38 54, 38 68 Z" fill="currentColor" fillOpacity=".25" />
    <path d="M52 50 C 52 36, 60 26, 70 22 C 70 34, 64 44, 52 50 Z" fill="currentColor" fillOpacity=".25" />
    <path d="M48 56 C 62 56, 74 50, 82 42 C 72 38, 58 42, 48 56 Z" fill="currentColor" fillOpacity=".25" />
    <path d="M30 78 C 42 80, 54 76, 60 70 C 50 64, 38 68, 30 78 Z" fill="currentColor" fillOpacity=".25" />
  </svg>
);

export const Cup = ({ className = "" }) => (
  <svg viewBox="0 0 64 64" className={className} {...base} strokeWidth="2.5">
    <path d="M12 26 H44 V40 C44 48 38 54 28 54 C18 54 12 48 12 40 Z" />
    <path d="M44 30 C52 30 54 40 44 42" />
    <path d="M22 18 C20 14 24 12 22 8" /><path d="M30 18 C28 14 32 12 30 8" /><path d="M38 18 C36 14 40 12 38 8" />
    <path d="M24 38 C24 35 28 35 28 38 C28 35 32 35 32 38 C32 41 28 43 28 44 C28 43 24 41 24 38 Z" fill="#E06B3F" stroke="#E06B3F" strokeWidth="1" />
  </svg>
);

export const Flag = ({ className = "" }) => (
  <svg viewBox="0 0 60 80" className={className} {...base} strokeWidth="2.5">
    <path d="M18 72 V10" /><path d="M18 10 L46 18 L18 28" fill="#E06B3F" stroke="#E06B3F" />
    <path d="M2 78 C 8 74, 14 74, 18 72" strokeDasharray="3 5" />
  </svg>
);

export const TownHall = ({ className = "" }) => (
  <svg viewBox="0 0 90 50" className={className} {...base} strokeWidth="2">
    <path d="M2 46 H88" /><path d="M14 46 V24 L24 16 L34 24 V46" /><path d="M40 46 V14 L48 6 L56 14 V46" />
    <path d="M62 46 V26 H80 V46" /><path d="M45 22 H51 V28 H45 Z" /><path d="M20 30 H28" /><path d="M67 32 H75" />
  </svg>
);

export const OrganicSectionDivider = ({ className = "", color = "#FAF7F1", flip = false }) => (
  <svg viewBox="0 0 1440 90" preserveAspectRatio="none" className={`block w-full h-[50px] sm:h-[80px] ${flip ? "rotate-180" : ""} ${className}`} aria-hidden="true">
    <path d="M0 40 C 240 90, 480 0, 760 38 S 1240 80, 1440 30 V90 H0 Z" fill={color} />
  </svg>
);
